<template>
  <div class="hover-container">
    <span class="text"><slot name="text" /></span><img src="@/assets/images/info.svg" />
    <div class="hover-container-content-container">
      <div class="hover-container-content">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HoverContainer",
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";
@import "@/assets/styles/_mixins.scss";

$tooltipImageSize: 1rem;
$padding: 0.25rem;
$tooltipWidth: 400px;

.hover-container {
  position: relative;
  z-index: 500;

  .text {
    font: normal normal normal 13px/16px "csr";
  }

  img {
    width: $tooltipImageSize;
    height: $tooltipImageSize;
    border-radius: calc($tooltipImageSize / 2);
    padding: $padding;
    margin-left: 0.5rem;
    margin-top: -0.25rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    @include shadow(100%);

    max-width: 100%;
    max-height: 100%;
  }

  &:has(.visible-xs) {
    display: inline-flex !important;
  }

  .hover-container-content-container {
    $width: 60vw;
    $top: 200px;
    display: none;
    z-index: 1000;
    visibility: hidden;
    position: fixed;
    width: $width;
    left: calc((100vw - $width) / 2);
    top: $top;
    text-align: center;

    .hover-container-content {
      :deep(img) {
        margin: 0 auto;
        width: auto;
        max-width: 100% !important;
        max-height: calc(100vh - $top);
        margin-left: -15px;
        @include shadow(2rem);
      }
    }
  }

  &:hover {
    .hover-container-content-container {
      display: block;
      visibility: visible;
      z-index: 1000;
    }
  }

  @media (max-width: $screen-xs-max) {
    .hover-container-content-container {
      $width: 90vw;
      $top: 250px;
      width: $width;
      left: calc((100vw - $width) / 2);
      top: $top;

      .hover-container-content {
        :deep(img) {
          margin: 0 auto;
          width: auto;
          max-width: 100% !important;
          max-height: calc(100vh - $top);
          @include shadow(1rem);
        }
      }
    }
  }
}
</style>
